export default "__VITE_ASSET__adOXnHiT__"